import { useState, useEffect, useCallback, cloneElement } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { updateUserProfile } from "../Actions/user";

const useEditProfileFacade = () => {
    const { user, loading } = useSelector((state) => state.user);
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({});
    const [isDirty, setIsDirty] = useState(false);
    const [btnText, setBtnText] = useState("Save Changes");
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const setDefaultData = useCallback(() => {
        if (user) {
            setFormData({
                name: user.name || "",
                email: user.email || "",
                collegeName: user.collegeName|| "",
                branch: user.branch || "",
                graduationYear: user.graduationYear || "",
                linkedinLink: user.linkedinLink || "",
                githubLink: user.githubLink || "",
                leetcodeLink: user.leetcodeLink || "",
                codeforcesLink: user.codeforcesLink || "",
                codechefLink: user.codechefLink || "",
            });
            setIsDirty(false);
        }
    }, [user]);

    useEffect(() => {
        setDefaultData();
    }, [setDefaultData]);

    const handleChange = (name, value) => {
        if (user.isEmailVerified && name === "email") return;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setIsDirty(true);
        setBtnText("Save Changes");
    };

    const updateProfile = async (e) => {
        if (e) e.preventDefault();

        if (!user.isEmailVerified) {
            toast.error("Please verify your email before updating profile");
            return;
        }

        try {
            setShowStatusModal(true);
            setIsUpdating(true);
            setIsSuccess(false);
            setBtnText("Updating...");

            await dispatch(updateUserProfile(formData));

            setIsSuccess(true);
            setIsUpdating(false);
            setBtnText("Saved!");
            setIsDirty(false);

            setTimeout(() => {
                setShowStatusModal(false);
                setIsSuccess(false);
            }, 2000);
        } catch (err) {
            setShowStatusModal(false);
            setIsUpdating(false);
            setBtnText("Try Again");
            toast.error(err.response?.data?.message || "Update Failed");
        }
    };

    return {
        user,
        loading,
        formData,
        isDirty,
        btnText,
        showStatusModal,
        setShowStatusModal,
        isUpdating,
        isSuccess,
        handleChange,
        updateProfile,
        setDefaultData,
    };
};

export default useEditProfileFacade;
